import { NAVIGATION_HISTORY_STACK_CACHE_KEY } from './constants';
import NavigationHistoryEntry from './NavigationHistoryEntry';
export function getNavigationHistoryStackCacheKey(navigation) {
    return `${NAVIGATION_HISTORY_STACK_CACHE_KEY}_${navigation.key}`;
}
export default class NavigationHistoryStack {
    constructor(navigation) {
        this.navigation = navigation;
        let stack = [];
        try {
            stack = JSON.parse(sessionStorage.getItem(getNavigationHistoryStackCacheKey(navigation)) || '[]').map((entryCache, index) => {
                return new NavigationHistoryEntry(entryCache.index, entryCache.url, entryCache.key, entryCache.id);
            });
        }
        catch (error) {
            stack = [];
        }
        this.stack = stack;
    }
    entries() {
        return this.stack;
    }
    push(entry) {
        try {
            this.stack = this.stack.slice(0, entry.index);
            this.stack.push(entry);
            sessionStorage.setItem(getNavigationHistoryStackCacheKey(this.navigation), JSON.stringify(this.stack));
        }
        catch (error) {
            // TODO: overflow
        }
    }
    replace(entry) {
        this.stack.splice(entry.index, 1, entry);
        try {
            sessionStorage.setItem(getNavigationHistoryStackCacheKey(this.navigation), JSON.stringify(this.stack));
        }
        catch (error) {
            // TODO: overflow
        }
    }
}
